import Splide from '@splidejs/splide'
import GLightbox from 'glightbox'

import { getClosestElement, getElements } from '../../../../Resources/Private/TypeScript/Utility/Dom'

class ImageSlider {
  private lightboxOptions: object = {
    closeEffect: 'fade',
    height: 1080,
    loop: true,
    openEffect: 'fade',
    width: 1920
  }

  private sliderOptions: object = {
    gap: '1.25rem',
    type: 'slide',
  }

  private sliders: NodeListOf<HTMLElement>

  constructor() {
    this.sliders = getElements('image-slider')
  }

  init(): void {
    this.sliders.forEach((slider: HTMLElement): void => {
      const splide = new Splide(slider, this.sliderOptions)
      const lightboxSelector = slider.getAttribute('data-id')
      const lightbox = GLightbox({
        ...this.lightboxOptions,
        selector: '[data-js=' + lightboxSelector + ']'
      })

      splide.mount()

      const slides = slider.querySelectorAll('.splide__slide')
      const controls = slider.querySelector('.splide__controls') as HTMLElement
      const perPage = splide.options.perPage as number

      if (slides.length <= perPage && controls) {
        controls.style.display = 'none'
      }

      document.addEventListener('click', (event): void => {
        let clickedElement = event.target as HTMLElement

        if (getClosestElement(clickedElement, lightboxSelector) === null) {
          return
        }

        clickedElement = getClosestElement(clickedElement, lightboxSelector)
        const galleryItem = getClosestElement(clickedElement, 'gallery-item')
        if (galleryItem === null) {
          return
        }

        if (galleryItem.classList.contains('splide__slide--clone') === false) {
          return
        }

        event.preventDefault()
        lightbox.openAt(+clickedElement.getAttribute('data-id'))
      })
    })
  }
}

const imageSlider = new ImageSlider()
imageSlider.init()
